/**
 * Airline compatibility block: scroll track on prev/next arrow click.
 * Hides prev at start, next at end.
 */
(function () {
  function updateArrows(wrap, track) {
    if (!wrap || !track) return;
    var left = track.scrollLeft;
    var maxLeft = track.scrollWidth - track.clientWidth;
    wrap.classList.toggle('at-start', left <= 1);
    wrap.classList.toggle('at-end', maxLeft <= 1 || left >= maxLeft - 1);
  }

  function init() {
    document.querySelectorAll('[data-airline-scroll]').forEach(function (track) {
      var wrap = track.closest('.product-airline-compat__scroll-wrap');
      if (!wrap) return;
      var prevBtn = wrap.querySelector('.product-airline-compat__arrow--prev');
      var nextBtn = wrap.querySelector('.product-airline-compat__arrow--next');
      var step = 160;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step, behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step, behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        updateArrows(wrap, track);
      });

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          updateArrows(wrap, track);
        });
        ro.observe(track);
      }

      updateArrows(wrap, track);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
